var ___EXPOSE_LOADER_IMPORT___ = require("-!./debug-require.cjs");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../node_modules/.pnpm/expose-loader@5.0.1_webpack@5.99.9/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["require"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["require"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
